export const saveFileFromBlob = (data, filename, type) => {
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(
    new Blob([data], {
      type,
    }),
  )
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()

  setTimeout(() => {
    window.URL.revokeObjectURL(link.toString())
  }, 200)
}
